import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RaiseColors } from "client/componentLibrary";
import { Inter, InterMedium, InterSemiBold, InterBold, InterExtraBold } from "../../../fonts/index";
import { RaiseTypography } from "componentLibrary";
import { createTheme } from "@mui/material/styles";

/* This uses Typescript's module augmentation to patch Material UI's existing Color Palette
 * to add our own custom colors for use through MUI's theme.palette object.
 * https://material-ui.com/customization/palette/#adding-new-colors
 */
//@ts-ignore to fix CI

var muiTheme = createTheme({
  palette: _objectSpread(_objectSpread({
    text: {
      primary: RaiseColors.destructive500,
      secondary: RaiseColors.shamrock
    }
  }, RaiseColors), {}, {
    // Material UI's default intention palettes
    primary: {
      main: RaiseColors.glacier1100
    },
    secondary: {
      main: RaiseColors.shamrock
    },
    error: {
      main: RaiseColors.destructive500
    },
    warning: {
      main: RaiseColors.warning
    },
    info: {
      main: RaiseColors.grape
    },
    success: {
      main: RaiseColors.onMarket
    },
    background: {
      "default": RaiseColors.white
    }
  }),
  typography: _objectSpread({}, RaiseTypography),
  breakpoints: {
    keys: ["xs", "sm", "smMd", "md", "lg", "tablet", "laptop", "xl"],
    values: {
      xs: 0,
      sm: 320,
      smMd: 600,
      md: 768,
      lg: 1024,
      tablet: 1152,
      laptop: 1280,
      xl: 1440
    }
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard"
      }
    },
    MuiTabs: {
      defaultProps: {
        indicatorColor: "secondary",
        textColor: "inherit"
      }
    },
    MuiSwitch: {
      defaultProps: {
        color: "secondary"
      }
    },
    MuiSelect: {
      defaultProps: {
        variant: "standard"
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "unset"
        }
      }
    },
    MuiLink: {
      defaultProps: {
        underline: "hover"
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: function root(_ref) {
          var ownerState = _ref.ownerState,
            theme = _ref.theme;
          return _objectSpread({}, ownerState.orientation === "vertical" && ownerState.variant === "middle" && {
            marginLeft: "16px",
            marginRight: "16px"
          });
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: [{
          "@font-face": Inter
        }, {
          "@font-face": InterMedium
        }, {
          "@font-face": InterSemiBold
        }, {
          "@font-face": InterBold
        }, {
          "@font-face": InterExtraBold
        }],
        body: {
          fontSize: "0.875rem",
          lineHeight: 1.43,
          letterSpacing: "0.01071em"
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: RaiseColors.white,
          border: "solid 1px",
          color: RaiseColors.black,
          borderRadius: "0px",
          borderColor: RaiseColors.white
        },
        input: {
          paddingLeft: 12,
          paddingRight: 12,
          paddingTop: 8,
          paddingBottom: 8,
          boxSizing: "border-box",
          height: 36
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          /// MUI defaults to using a gray tint for button hover states.
          /// Most of our designs have background colors or white backgrounds for the hover state.
          /// Example: https://www.figma.com/file/jeuu7WC3j7jkAqoZjktLHl/Client-Exploration?node-id=3607%3A2108
          "&:hover": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  }
});
export default muiTheme;